import { Text, Card } from '@mantine/core'
import { clsx } from '@mantine/styles'

import { Icon, Badge } from '@percent/lemonade'

import type { SelectOptionCardProps } from './select-option-card.types'
import classes from './select-option-card.module.scss'

export function SelectOptionCard({
  testId,
  icon,
  badge,
  title,
  description,
  active,
  onClick,
}: Readonly<SelectOptionCardProps>) {
  return (
    <Card
      data-testid={testId}
      onClick={onClick}
      className={clsx(classes.Card, { [classes.Active]: active })}
    >
      {icon ? <Icon name={icon} size={6} color="primary400" /> : null}
      {badge ? <Badge variant="informative">{badge}</Badge> : null}
      <Text
        className={classes.Title}
        style={{ marginTop: icon || badge ? '1rem' : 0 }}
        component="p"
      >
        {title}
      </Text>
      {description ? (
        <Text className={classes.Description} component="p">
          {description}
        </Text>
      ) : null}
    </Card>
  )
}
